import DatePicker from 'material-ui/DatePicker';
import globals from '../../../globals/communityGlobals';

class DatePickerWrapper extends DatePicker {
  // Override the internal DatePicker logic to use globals date instead
  openDialog = () => {
    if (this.state.date !== undefined) {
      this.setState(
        {
          dialogDate: this.getDate(),
        },
        this.refs.dialogWindow.show,
      );
    } else {
      this.setState(
        {
          dialogDate: globals.now.startOf('day').toDate(),
        },
        this.refs.dialogWindow.show,
      );
    }
  };
}

export default DatePickerWrapper;
